import { useNavigate } from 'react-router-dom';

export default function Welcome() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-[#E8F5F3]">
      {/* Header */}
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center bg-[#0F2A3A] rounded-xl">
              <i className="ri-file-list-3-line text-2xl text-[#1ABC9C]"></i>
            </div>
            <span className="text-2xl font-bold text-[#0F2A3A]">منصة التقييم التعليمي</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-6xl font-bold text-[#0F2A3A] mb-6 leading-tight">
            نظام الاختبارات الذكية والتقييم الفوري
          </h1>
          <p className="text-2xl text-slate-600 mb-12 leading-relaxed">
            منصة تعليمية احترافية للاختبارات الإلكترونية التفاعلية مع تحليل فوري للأداء وتقارير تفصيلية لتطوير مستواك الأكاديمي
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <button
              onClick={() => navigate('/login')}
              className="px-8 py-4 bg-[#0F2A3A] text-white text-lg font-semibold rounded-xl hover:bg-[#1a3d52] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-login-box-line ml-2"></i>
              تسجيل الدخول
            </button>
            <button
              onClick={() => navigate('/home')}
              className="px-8 py-4 bg-[#1ABC9C] text-white text-lg font-semibold rounded-xl hover:bg-[#16a085] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-eye-line ml-2"></i>
              الدخول كزائر
            </button>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-8 mt-20">
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-[#E8F5F3] rounded-2xl">
                <i className="ri-timer-line text-4xl text-[#1ABC9C]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#0F2A3A] mb-3">تقييم فوري</h3>
              <p className="text-slate-600 leading-relaxed">
                احصل على نتائجك وتحليل أدائك فور انتهاء الاختبار مع توصيات تعليمية ذكية
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-[#E8F5F3] rounded-2xl">
                <i className="ri-bar-chart-box-line text-4xl text-[#1ABC9C]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#0F2A3A] mb-3">تحليل الأداء</h3>
              <p className="text-slate-600 leading-relaxed">
                تقارير تفصيلية ورسوم بيانية توضح تطور مستواك ونقاط القوة والضعف
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-[#E8F5F3] rounded-2xl">
                <i className="ri-question-answer-line text-4xl text-[#1ABC9C]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#0F2A3A] mb-3">أسئلة تفاعلية</h3>
              <p className="text-slate-600 leading-relaxed">
                أنواع متعددة من الأسئلة: اختيار متعدد، صح وخطأ، سحب وإفلات، وأكثر
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
